import { Component, Input, OnInit } from '@angular/core';

import { ProductDetailsHeaderComponent } from '../../../product/product-details-header/product-details-header.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { DeliveryItemActionsBlockComponent } from './delivery-item-actions-block/delivery-item-actions-block.component';
import { MenuModule } from 'primeng/menu';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IOrderReturnDialogData, OrderReturnDialogComponent } from '../../../../dialogs/order-return-dialog/order-return-dialog.component';
import { MenuItem } from 'primeng/api';
import { OrderReturnDialogSuccessComponent } from '../../../../dialogs/order-return-dialog-success/order-return-dialog-success.component';
import { HistoryAndChatDialogComponent } from '../../../../dialogs/history-and-chat-dialog/history-and-chat-dialog.component';
import { Order, OrderLine, RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables } from '../../../../../graphql/generated/generated-types';
import { AssetPreviewPipe } from '../../../../pipes/asset-preview.pipe';
import { DataService } from '../../../../../core/providers/data/data.service';
import { REMOVE_ITEM_FROM_CART } from '../../../product/price-and-actions-block/product-cart.graphql';
import { Observable, of, take } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ProductImageWrapperComponent } from '../../../product/product-image-wrapper/product-image-wrapper.component';
import { DeleteCartItemBtnBlockComponent } from '../../delete-cart-item-btn-block/delete-cart-item-btn-block.component';

@Component({
  selector: 'app-delivery-item-card',
  standalone: true,
  imports: [CommonModule, ProductDetailsHeaderComponent, ButtonModule, RippleModule,
    DeliveryItemActionsBlockComponent, MenuModule, OrderReturnDialogComponent,
    OrderReturnDialogSuccessComponent, HistoryAndChatDialogComponent,
    AssetPreviewPipe, ProductImageWrapperComponent, DeleteCartItemBtnBlockComponent],
  templateUrl: './delivery-item-card.component.html',
  styleUrl: './delivery-item-card.component.scss'
})
export class DeliveryItemCardComponent implements OnInit {
  @Input() orderLine: OrderLine;
  @Input() product: any;
  @Input() inOrder: boolean = false;
  @Input() inCart!: boolean;
  @Input() order: Order;

  public loading$: Observable<boolean>;
  public orderActions: MenuItem[] | undefined = [
    {
      label: 'Arrange return',
      command: (event) => {
        this.openOrderItemReturnDialog();
      }
    },
    {
      label: 'View history and talk',
      command: (event) => {
        this.openOrderHistoryAndChatDialog();
      }
    },
  ]

  public stockLevel: number;

  constructor(private dialogService: DialogService, private dataService: DataService) {
  }

  ngOnInit(): void {
    if (this.orderLine) {
      this.stockLevel = this.convertStringToNumber(this.orderLine?.productVariant?.stockLevel || '0');
    } else if (this.product) {
      this.stockLevel = this.convertStringToNumber(this.product?.variants?.[0].stockLevel || '0');
    }
  }

  public convertStringToNumber(value: string): number {

    return parseFloat(value);
  }


  public removeItem(id: string) {
    this.loading$ = of(true);
    this.dataService.mutate<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(REMOVE_ITEM_FROM_CART, {
      id,
    }).pipe(
      take(1),
    ).subscribe({
      complete: () => {
        this.loading$ = of(false);
      }
    });
  }

  public openOrderHistoryAndChatDialog() {
    const dialogRef: DynamicDialogRef = this.dialogService.open(HistoryAndChatDialogComponent,
      {
        data: {
        } as any,
        modal: true,
        dismissableMask: true,
        styleClass: 'c-dialog medium-dialog',
        header: 'View history and talk',
      });

    dialogRef.onClose.subscribe((result) => {
      if (result) {

      }
    })
  }

  public openOrderItemReturnDialog() {
    const dialogRef: DynamicDialogRef = this.dialogService.open(OrderReturnDialogComponent,
      {
        data: {
        } as IOrderReturnDialogData,
        modal: true,
        dismissableMask: true,
        styleClass: 'c-dialog medium-dialog',
        header: 'Arrange return',
      });

    dialogRef.onClose.subscribe((result) => {
      if (result) {
        const successDialogRef: DynamicDialogRef = this.dialogService.open(OrderReturnDialogSuccessComponent,
          {
            data: {
            } as any,
            modal: true,
            dismissableMask: true,
            styleClass: 'c-dialog medium-dialog',
            header: 'Arrange return',
          });

        successDialogRef.onClose.subscribe((result) => {

        })
      }
    })
  }
}
